import { gql } from '@apollo/client';

import { USER_FRAGMENT } from '../../fragments/user';

export const GET_CLINICAL_USER_PATIENTS = gql`
  query GetClinicalUserPatients(
    $medicalPracticeId: Float!
    $clinicalUserId: Float!
  ) {
    getClinicalUserPatients(
      medicalPracticeId: $medicalPracticeId
      clinicalUserId: $clinicalUserId
    ) {
      id
      status
      user {
        ...UserFragment
      }
    }
  }
  ${USER_FRAGMENT}
`;
